import type { Book } from "@book-club/shared";
import { useQuery } from "@tanstack/react-query";
import booksService from "@/features/books/services/booksService";
import DURATIONS from "@/shared/constants/durations";
import { booksKeys } from "./booksQueryKeys";

/**
 * Fetches a single book by ID from Firestore
 * Uses normal staleTime (5 minutes) for individual book queries
 * @param bookId - Book document ID to fetch
 * @returns Query result with single book or undefined if not found
 */
export function useBookById(bookId: string) {
    return useQuery<Book | null, Error>({
        gcTime: DURATIONS.ONE_DAY,
        queryFn: () => booksService.getBookById(bookId),
        queryKey: booksKeys.detail(bookId),
        staleTime: DURATIONS.FIVE_MINUTES,
    });
}
